import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { Flex, Box } from 'grid-styled'
import { withRouter } from 'react-router-dom'
import { utils } from 'alelo-logic'

import TextInput from 'app/elements/TextInput'
import Button from '../../elements/Button'
import Radio from '../../elements/Radio'

import { buttons } from './data.json'

import { ParagraphGrayLabel } from '../../pages/BlockIdentifiers/styles'

const renderRadio = ({ input, label }) => <Radio {...input} label={label} />

const renderOtherMotive = ({ placeholder, input, onChange, value, meta: { touched, error } }) => (
  <div>
    <ParagraphGrayLabel>DESCREVA O MOTIVO</ParagraphGrayLabel>
    <TextInput
      {...input}
      placeholder={placeholder}
      maxlength="40"
      lengthCounter
      errorMessage={touched && error}
    />
  </div>
)

const BlockIdentifiersForm = props => {
  const { handleSubmit, pristine, history, reasonList, handleChangeReason, reasonSelected } = props

  return (
    <form onSubmit={handleSubmit}>
      {reasonList &&
        reasonList.map(item => (
          <Box mb={24} key={item.chave}>
            <Field
              component={renderRadio}
              label={item.descricao}
              name="option"
              value={item.chave}
              type="radio"
              onChange={evt => handleChangeReason(evt.target.value)}
            />
          </Box>
        ))}
      {reasonSelected === 'OUTRO' && (
        <Box mb={20}>
          <Field
            component={renderOtherMotive}
            placeholder="Digite aqui"
            name="descricaoOutroProblema"
            validate={utils.emptyFieldValidate}
            isRequired
          />
        </Box>
      )}
      <Flex wrap mt={60}>
        <Box width={[1, 'auto']}>
          <Button buttonType="white" onClick={() => history.goBack()} text={buttons.back} />
        </Box>
        <Box width={[1, 'auto']} ml={[0, 30]} mt={[20, 0]}>
          <Button disabled={pristine} type="submit" text={buttons.next} />
        </Box>
      </Flex>
    </form>
  )
}

export default reduxForm({
  form: 'formBlockChangeidentifier',
  destroyOnUnmount: true
})(withRouter(BlockIdentifiersForm))



// WEBPACK FOOTER //
// ./src/app/modules/BlockIdentifiersForm/index.js